import { call } from '../../../../stent/call';
export const makeUpdateNote = function(ctx) {
    const { updateCartNote  } = ctx;
    return function* updateNote(machine, payload) {
        try {
            if (machine.state.contents == null) {
                throw new Error('Cart contents missing');
            }
            yield {
                name: 'Updating',
                error: null,
                contents: machine.state.contents
            };
            try {
                yield call(updateCartNote, payload);
            } catch (err) {
                console.error('Cart note update failed', err);
            }
            yield {
                name: 'Stale',
                error: null,
                contents: machine.state.contents
            };
            machine.refresh();
        } catch (err) {
            yield {
                error: err instanceof Error ? err : new Error('Unknown error [e9a6faf592024eae8f9dae864776906e]'),
                name: 'Failure',
                contents: machine.state.contents
            };
        }
    };
};
